import { useState } from 'react';

import GenericAccordian from '../../components/GenericAccordian/GenericAccordian';
import { ORDER_USER } from '../../constants/EntityName';
import { getFormDefaultValue, getTableHeaders } from '../../utils/forms/FormDataModel';
import { TabContent, OnAddArguments, ContentItem } from '../../utils/forms/FormInterface';
import AbstractForm from '../Entity/AbstractForm';
import AbstractLanding from '../Entity/AbstractLanding';
import AbstractTabs, { TabActiosProps, TabActiosEventType } from '../Entity/AbstractTabs';
import { SignedUpUsersFormData } from '../../datamodels/SignedUpUsers';
import UserOrderHistory from '../../components/UserOrderHistory';
import HorizontalTabNavigation, {
  HorizontalTabPanel,
} from '../../components/HorizontalTabNavigation/HorizontalTabNavigation';

const editFormTemplate = SignedUpUsersFormData.map((field: any) =>
  field.editReadOnly ? { ...field, readonly: true } : field
);

const SignedUpUsers = () => {
  const [activeKey, setActiveKey] = useState<string>('0');
  const [userName, setUserName] = useState<string>();
  const [showFormComponent, setShowFormComponent] = useState<boolean>(false);
  const [refreshData, setRefreshData] = useState<boolean>(false);
  const [content, setContent] = useState<TabContent>([]);
  const defaultFormValue: any = getFormDefaultValue(SignedUpUsersFormData);
  const tableHeaders: any = getTableHeaders(SignedUpUsersFormData);
  const addName = 'Documitra Users';
  const headerName = 'Documitra Users';

  const onSuccessful = (id?: string) => {
    if (id === 'create') {
      setShowFormComponent(false);
    }
    onTabClick('0');
    setRefreshData(prev => !prev);
  };

  const onAddNew = (argument1?: OnAddArguments) => {
    if (argument1) {
      const checkArr = content.filter((item: ContentItem) => item.key === argument1.id);
      checkArr.length ? null : onAdd(argument1);
    } else {
      setShowFormComponent(true);
      setUserName('Add Documitra Users');
      onTabClick('a');
    }
  };

  const closeTab = (key: string, shouldRefresh: boolean) => {
    setContent(content => content.filter(item => item.key !== key));
    setActiveKey('0');
    shouldRefresh && setRefreshData(prev => !prev);
    key === 'a' && setShowFormComponent(false);
  };

  const onAdd = (argument1: OnAddArguments) => {
    const newObj = {
      key: argument1.id,
      tabTitle: argument1.name,
      content: (
        <GenericAccordian key={content.length}>
          <AbstractForm
            entityId={argument1.id}
            isCreateMode={false}
            headerName={headerName}
            entityName={ORDER_USER}
            formTemplate={editFormTemplate}
            formDefaultPayload={getFormDefaultValue(SignedUpUsersFormData)}
            onSuccessfulUpdate={onSuccessful}
            formHeader=""
            showDeleteDraft={true}
            closeTab={closeTab}
            hiddenButtons={{ cancel: true }}
          />
          {argument1.id && <UserOrderHistory userId={argument1.id} />}
        </GenericAccordian>
      ),
    };

    // Below line of code is for show tab index when we select tab
    setContent((prev: any) => [...prev, newObj]);
    argument1.id && setActiveKey(String(argument1.id));
  };

  const onTabClick = (key: string) => {
    setActiveKey(key);
  };

  const updateFormVisibility = (
    action: TabActiosProps,
    targetKey?: string | TabActiosEventType
  ) => {
    if (action === 'remove') {
      if (targetKey === 'a') {
        setShowFormComponent(false);
        onTabClick('0');
      } else {
        onTabClick('0');
        // whenever a tab is closed, that tab is filtered out from the list of tabs which are rendered inside the AbstractTab component
        setContent(content => content.filter(item => String(item.key) !== targetKey));
      }
    }
  };

  return (
    <AbstractTabs
      activeKey={activeKey}
      entityName="Documitra Users"
      updateFormVisibility={updateFormVisibility}
      onTabClick={onTabClick}
      secondTabTitle={userName}
      showFormComponent={showFormComponent}
      content={content}
      formComponent={
        <GenericAccordian>
          <AbstractForm
            isCreateMode={true}
            headerName={headerName}
            entityName={ORDER_USER}
            formTemplate={SignedUpUsersFormData}
            formDefaultPayload={defaultFormValue}
            onSuccessfulUpdate={onSuccessful}
            closeTab={closeTab}
          />
        </GenericAccordian>
      }
    >
      <AbstractLanding
        headerName={headerName}
        addName={addName}
        entityName={ORDER_USER}
        tableHeaders={tableHeaders}
        onAdd={onAddNew}
        refreshData={refreshData}
        disableAdd
        showDownload={false}
        showFilter={true}
        reportRedirectPath="/documitra-reports"
      />
    </AbstractTabs>
  );
};

export default SignedUpUsers;
